import * as v from "valibot";

// request
export const RequestSchema = v.object({
  Action: v.nullish(v.string()),
  ClusterId: v.string(),
  Version: v.nullish(v.string()),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response
const DataSchema = v.object({
  IsApiServerInstalling: v.boolean(),
  IsControllerInstalling: v.boolean(),
  IsScheduleInstalling: v.boolean(),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
